import { 
    apiRequest,
    ListStatus
 } from '../../../../../services/adapters/kepegawaian/riwayatnikahService'

class IndexRepository {

    fetchStatus = async (query, cancelToken) => {
        return await apiRequest("get", ListStatus, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default IndexRepository;